import * as React from "react";
import { SVGProps } from "react";

export const EventGoalSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={42}
		height={42}
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect width={42} height={42} rx={6} fill="#0050FF" fillOpacity={0.08} />
		<path
			opacity={0.32}
			d="M21 30.8574C26.5228 30.8574 31 29.2904 31 27.3574C31 25.4244 26.5228 23.8574 21 23.8574C15.4772 23.8574 11 25.4244 11 27.3574C11 29.2904 15.4772 30.8574 21 30.8574Z"
			fill="#0050FF"
			fillOpacity={0.48}
		/>
		<path
			d="M21 10.1074C21.1989 10.1074 21.3897 10.1864 21.5303 10.3271C21.671 10.4677 21.75 10.6585 21.75 10.8574V11.8934L26.758 14.3974L26.812 14.4244C27.546 14.7914 28.172 15.1044 28.608 15.4084C29.05 15.7174 29.514 16.1644 29.514 16.8574C29.514 17.5504 29.05 17.9974 28.608 18.3064C28.172 18.6104 27.546 18.9234 26.812 19.2904L21.75 21.8204V26.8574C21.75 27.0563 21.671 27.2471 21.5303 27.3878C21.3897 27.5284 21.1989 27.6074 21 27.6074C20.8011 27.6074 20.6103 27.5284 20.4697 27.3878C20.329 27.2471 20.25 27.0563 20.25 26.8574V10.8574C20.25 10.6585 20.329 10.4677 20.4697 10.3271C20.6103 10.1864 20.8011 10.1074 21 10.1074Z"
			fill="#0050FF"
			fillOpacity={0.48}
		/>
	</svg>
);
